<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="webpageWrap preview">
    <img :src="webpage" />
    <span v-if="isPreview" class="preview-media-badge">第 {{ step }} 步</span>
  </div>
</template>

<script>
import previewMediaMixin from "@/utils/previewMediaMixin";

export default {
  mixins: [previewMediaMixin],
  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
    isPreview: Boolean,
  },
  data() {
    return {
      webpage: require("../assets/webpage.jpg"),
      step: 1,
    };
  },
  methods: {
    handlePreviewMediaEvent(event) {
      if (event === "prev") {
        this.step = Math.max(1, this.step - 1);
      } else if (event === "next") {
        this.step += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.webpageWrap {
  width: 100%;
  height: 100%;
  user-select: none;
  position: relative;
  img {
    width: 100%;
    max-height: 100%;
  }
}
.preview-media-badge {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  pointer-events: none;
}
</style>
